/**
 * @class
 * @name AtmoSphere
 * @desc 천체의 대기 클래스
 */
var AtmoSphere = /** @class */ (function () {
    function AtmoSphere(components) {
        this.components = [];
        this.components = components;
    }
    AtmoSphere.prototype.getAllComponents = function () {
        return this.components;
    };
    AtmoSphere.prototype.getComponentsById = function (id) {
        var component = this.components.filter(function (v) { return v.id === id; });
        return component[0];
    };
    AtmoSphere.prototype.getHighestRateComponent = function () { };
    AtmoSphere.prototype.getLowestRateComponent = function () { };
    return AtmoSphere;
}());
export { AtmoSphere };
